<script>
    import {
        TertiaryButton,
        Typography,
        InputFile,
        InputDate,
        Row,
        Select,
        TextArea,
    } from '../UI'
    import Docs from '../Icons/custom/Docs.svelte'
    import dictionaries from '../../stores/dictionaries'
    import { AddCircle, ChevronFordware } from '../Icons'
    import { API_URL } from '$lib/conf'
    import TrashOutline from '../Icons/TrashOutline.svelte'
    import { createEventDispatcher, getContext, onDestroy } from 'svelte'
    import { createVirtualList, isPdf } from '$lib/utils'
    export let label = ''
    export let contract = false
    export let inputs = []
    export let secondary = {}
    export let multi = false
    export let required = false
    export let optional = false
    export let impuesto = ''
    export let title = null
    export let type = null
    export let valid = true
    export let value = multi ? [] : {}
    export let deleteable = false
    export let validation = null
    export let name = null
    export let style = ''
    export let labelSuffix = 'Agregar'
    const dispatch = createEventDispatcher()
    const formData = getContext('formData')
    let data = value
    let validations = {}
    let multiValidations = {}
    let mvalues = createVirtualList(
        value instanceof Array ? value : [],
        value instanceof Array ? value.length + 2 : 0
    )
    function onChange(d) {
        dispatch('change', d)
    }
    function onDelete(d) {
        dispatch('delete', d)
    }
    let instanced = optional
        ? Object.entries(value).filter(([k]) => !['impuesto'].includes(k))
              .length > 1
        : true
    let labelRef = label
    let tipo_doc = [
        { label: 'Constancia ARCA', value: '1' },
        { label: 'Constancia Ingresos Brutos', value: '2' },
        { label: 'Certificado de Retencion', value: '3' },
        { label: 'Certificado de Exencion', value: '4' },
        { label: 'Otro', value: '5' },
    ]
    let ref = {
        fecha_vencimiento: 'Fecha de vencimiento',
        fecha_emision: 'Fecha de emisión',
        jurisdiccion: 'Jurisdicción',
        files: 'Archivo PDF',
        observacion: 'Campo de observaciones',
        secondary: 'Documentación secundaria',
    }
    value = { ...value, impuesto }
    $: requiredInputs = inputs
        .filter((i) => i.at(-1) === '*')
        .map((x) => x.slice(0, -1))
    $: allowedInputs = inputs.map((x) =>
        x.at(-1) === '*' ? x.slice(0, -1) : x
    )
    $: showAll =
        allowedInputs instanceof Array ? allowedInputs.length === 0 : false
    function allowInput(n) {
        return showAll || allowedInputs.includes(n)
    }
    function clearValue() {
        let def = {
            impuesto,
        }
        return def
    }
    // if (typeof type === 'string') {
    // }
    // Atributos dinamicos del label (titulo)
    $: dynamicAttr = Object.fromEntries(
        Object.entries(data)
            .filter(([k]) => !['secondary', 'files'].includes(k)) // blacklist
            .concat([
                [
                    'jurisdiccion_name',
                    data.jurisdiccion
                        ? $dictionaries?.jurisdicciones?.find(
                              (x) => x.value === data.jurisdiccion
                          )?.label || ''
                        : '',
                ],
                [
                    'tipo_documentacion_name',
                    data.tipo_documentacion
                        ? tipo_doc?.find(
                              (x) => x.value === data.tipo_documentacion
                          )?.label || 'Documentacion'
                        : 'Documentacion',
                ],
            ])
    )
    // Label dinamico
    $: label =
        labelRef
            .match(/\$\w+/g)
            ?.map((x) => x.slice(1))
            .reduce(
                (a, b) =>
                    a.replace(
                        '$' + b,
                        b in dynamicAttr ? dynamicAttr[b] || '' : ''
                    ),
                labelRef
            ) || label
    $: if (instanced) {
        contract = false
    }
    $: value = {
        ...data,
        title: label,
        tipo_documentacion: type,
        impuesto,
        ...$$restProps,
    }
    $: valids = Object.fromEntries(
        Object.entries(multiValidations).filter(([k]) =>
            $mvalues.map((x) => x.id).includes(parseInt(k))
        )
    )
    $: valid = multi
        ? Object.values(valids).every((x) => x)
        : Object.values(validations).every((x) => x)
    // Multiple docs config
    $: if (multi) {
        value = $mvalues
    }
    $: console.log({ multi, valid, value, validations })
    const dateValidation = (v) => {
        console.log({ dateValidation: v })
        return (
            typeof v === 'string' &&
            /^(\d{4}).(0[1-9]|1[1|2]).(0[1-9]|[1|2]\d|3[0|1])$/gm.test(v)
        )
    }
    function subscribe() {
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: !!valid,
                            validation: !!validation,
                            required,
                            value,
                            label,
                        },
                    ],
                ])
            )
        })
    }
    function unsubscribe() {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    }
    $: if (((value && name) || name) && formData) subscribe()
    // $: console.log({ requiredInputs })
    onDestroy((_) => {
        unsubscribe()
    })
</script>

{#if multi}
    {#each $mvalues as attr (attr.id)}
        <svelte:self
            {inputs}
            {impuesto}
            {secondary}
            deleteable
            label={labelRef}
            style="margin: 15px 0"
            bind:value={attr}
            bind:valid={multiValidations[attr.id]}
            on:delete={(_) => {
                mvalues.delete(attr.id)
                delete multiValidations[attr.id]
            }}
        />
    {/each}
    <TertiaryButton
        label={`${labelSuffix} ${label}`}
        on:click={(_) => mvalues.add()}
        icon={AddCircle}
    />
{:else if instanced}
    <div class="container" {style}>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span
            class="head"
            class:contract
            on:click={(_) => (contract = !contract)}
        >
            <span>
                <Docs />
                <Typography
                    color="black"
                    style="margin: 0; cursor: pointer; user-select: none"
                    type="h4">{label || title}</Typography
                >
            </span>
            <i class="ele">
                <ChevronFordware style="transform: rotate(90deg)" />
            </i>
        </span>
        {#if !contract}
            <div class="content">
                {#if !impuesto}
                    {#if allowInput('tipo_documentacion')}
                        <Select
                            required={requiredInputs.includes(
                                'tipo_documentacion'
                            )}
                            label="Tipo de documentacion"
                            options={tipo_doc}
                            bind:value={data.tipo_documentacion}
                            bind:valid={validations.tipo_doc}
                        />
                    {/if}
                {/if}
                <Row>
                    {#if allowInput('fecha_emision')}
                        <InputDate
                            required={requiredInputs.includes('fecha_emision')}
                            label="Fecha de emisión"
                            validation={(v) =>
                                requiredInputs.includes('fecha_emision')
                                    ? dateValidation(v)
                                    : true}
                            bind:value={data.fecha_emision}
                            bind:valid={validations.fecha_emision}
                        />
                    {/if}
                    {#if allowInput('fecha_vencimiento')}
                        <InputDate
                            required={requiredInputs.includes(
                                'fecha_vencimiento'
                            )}
                            label="Fecha de vencimiento"
                            validation={(v) =>
                                requiredInputs.includes('fecha_vencimiento')
                                    ? dateValidation(v)
                                    : true}
                            bind:value={data.fecha_vencimiento}
                            bind:valid={validations.fecha_vencimiento}
                        />
                    {/if}
                </Row>
                {#if allowInput('jurisdiccion')}
                    <Select
                        required={requiredInputs.includes('jurisdiccion')}
                        label="Jurisdicción"
                        options={$dictionaries.vprovincias}
                        validation={(n) =>
                            requiredInputs.includes('jurisdiccion')
                                ? n && n != ''
                                : true}
                        bind:value={data.jurisdiccion}
                        bind:valid={validations.jurisdiccion}
                    />
                {/if}
                {#if allowInput('files')}
                    <InputFile
                        required={requiredInputs.includes('jurisdiccion')}
                        style="flex-direction: row; width:100%; justify-content: space-between; margin-top: 8px; padding: 12px 24px 12px 12px"
                        endpoint={API_URL + '/upload'}
                        label="Selecciona el achivo pdf"
                        errMsg="Por favor cargue un documento en formato PDF"
                        validation={(d) =>
                            requiredInputs.includes('files')
                                ? d instanceof Array &&
                                  d.length > 0 &&
                                  d.every((f) => isPdf(f?.filename) || false)
                                : true}
                        preview
                        bind:value={data.files}
                        bind:valid={validations.files}
                    />
                {/if}
                {#if allowInput('observacion')}
                    <TextArea
                        bind:value={data.observacion}
                        bind:valid={validations.observacion}
                        validation={(r) =>
                            requiredInputs.includes('observacion')
                                ? r && r.length > 0
                                : true}
                        required={requiredInputs.includes('observacion')}
                        label="Observación"
                    />
                {/if}
                <!-- {#if secondary}
                    <br />
                    <svelte:self
                        {...secondary}
                        contract={true}
                        {impuesto}
                        bind:valid={validations.secondary}
                        bind:value={data.secondary}
                    />
                {/if} -->
                {#if optional || deleteable}
                    <span
                        style="width: 100%; padding: 15px 0 15px 0; display: flex; justify-content: flex-end; align-items: center;"
                    >
                        <TertiaryButton
                            label="Remover"
                            on:click={(_) => {
                                onDelete(value)
                                instanced = false
                                value = clearValue()
                                unsubscribe()
                            }}
                            icon={TrashOutline}
                        />
                    </span>
                {/if}
            </div>
        {/if}
        {#if !valid}
            <span class="err">
                <strong>Por favor revise la siguiente informacion:</strong>
                <ul>
                    {#each Object.entries(validations).filter(([_, k]) => !k) as [key]}
                        <li>{ref[key]}</li>
                    {/each}
                </ul>
            </span>
        {/if}
    </div>
{:else}
    <TertiaryButton
        label={`${labelSuffix} ${label}`}
        on:click={(_) => {
            instanced = true
            subscribe()
        }}
        icon={AddCircle}
    />
{/if}

<style>
    /* *:global(){
        user-select: none;
    } */
    .container {
        /* background: rgba(0, 0, 0, 0.015); */
        position: relative;
        width: 100%;
        height: fit-content;
        border-radius: 5px;
        border: 1px var(--color-grey-400) solid;
    }
    span {
        display: flex;
        width: 100%;
        flex-direction: row;
        gap: 15px;
    }
    .content {
        padding: 25px;
    }
    .head {
        padding: 15px 20px;
        width: 100%;
        /* height: fit-content; */
        cursor: pointer;
        justify-content: space-between;
        background: rgba(0, 0, 0, 0.03);
        display: flex;
        gap: 10px;
        position: relative;
        border-bottom: 1px var(--color-grey-400) solid;
    }
    .contract {
        border: none;
    }
    .contract i {
        transform: rotate(-90deg);
        transform-origin: center center;
    }
    .err {
        width: 100%;
        /* height: fit-content; */
        background: var(--color-accent-01-bg);
        display: flex;
        position: relative;
        flex-direction: column;
        color: var(--color-accent-01);
        padding: 15px;
    }

    .ele {
        display: flex;
        width: 25px;
        height: 25px;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: 0;
        position: relative;
    }
    /* ul {
        margin: 15px;
        padding: 0;
    } */
</style>
